/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmKonfiguracniSkupinaProgramovaInstance extends GContentBase<SeznamAdmKonfiguracniSkupinaProgramovaInstanceObj> {
        private seznamObj: SeznamAdmKonfiguracniSkupinaProgramovaInstanceObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmKonfiguracniSkupinaProgramovaInstanceObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmKonfiguracniSkupinaProgramovaInstanceNew",
                //contentCaption: (this.ixs_fun != null && this.ixs_fun != undefined) ? "jres:33000607" : "jres:29802871", 
                contentCaption: this.seznamObj.createContentCaptionExtend(),
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_usr_txt}<br />{ixs_ins_txt}"
                },
                gridSettings: {
                    columnOrder: this.getColumnOrder()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }

        private getColumnOrder(): string {
            if (this.ixs_fun || this.ixs_usr) 
                return "ixs_ins_txt,lic,dat_zmena,zmenu_provedl,lic,ixs_lpc"
            else 
                return "ixs_usr_txt,lic,dat_zmena,zmenu_provedl,lic,ixs_lpc"
        }
    }

    export class SeznamAdmKonfiguracniSkupinaProgramovaInstanceObj extends GAdmSeznamBase {
        ixs_usr: string;
        ixs_ins: string;
        ixs_fun: string;
        typ_usr: number;

        private funkcniMisto: boolean;

        create() {
            if (this.typ_usr == 10)
                this.funkcniMisto = true;
            else
                this.funkcniMisto = false;
        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmKonfiguracniSkupinaProgramovaInstance", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmKonfiguracniSkupinaProgramovaInstance",
                newRecord: isNew,
                ixs_fun: isNew == true ? ((this.ixs_fun) ? this.ixs_fun : null) : (this.ixs_fun) ? data.ixs_usr : null,
                ixs_usr: isNew == true ? ((this.ixs_usr) ? this.ixs_usr : null) : data.ixs_usr,
                ixs_ins: isNew == true ? ((this.ixs_ins) ? this.ixs_ins : null) : data.ixs_ins,
                lic: isNew == true ? null : data.lic,
                typ_usr: this.typ_usr
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29929931").addField("gselectbox", Gordic.Prefabs.Select.ginsins(), {
                name: "ixs_ins",
                model: "model.ixs_ins=value.ixs_ins",
                dropdown: true,
                disabled: (this.ixs_ins) ? true : false
            })
            if (this.funkcniMisto == false) {
                this.filterForm.addRow("jres:29932054").addField("gselectbox", Gordic.Prefabs.Select.ginsusr(), {
                    name: "ixs_usr",
                    model: "model.ixs_usr=value.ixs_usr",
                    dropdown: true,
                    disabled: (this.ixs_usr) ? true : false
                })
            } else {
                this.filterForm.addRow("jres:32131054").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                    name: "ixs_usr",
                    model: "model.ixs_usr=value.ixs_fun",
                    dropdown: true,
                    disabled: (this.ixs_fun) ? true : false
                })
            }
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_ins)
                hardFilter["ixs_ins"] = this.ixs_ins
            if (this.ixs_usr)
                hardFilter["ixs_usr"] = this.ixs_usr
            if (this.ixs_fun)
                hardFilter["ixs_usr"] = this.ixs_fun
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_ins)
                data["ixs_ins"] = this.ixs_ins;
            if (this.ixs_usr)
                data["ixs_usr"] = this.ixs_usr;
            if (this.ixs_fun)
                data["ixs_usr"] = this.ixs_fun
            data["typ_usr"] = this.funkcniMisto == true ? 10 : 0;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmKonfiguracniSkupinaProgramovaInstance.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.ixs_usr, data.ixs_ins, data.lic),
                nazev: ""
            }
        }

        createContentCaptionExtend(): string {
            if (this.typ_usr == 10) 
                return (this.ixs_ins) ? "jres:33000778" : "jres:33000607" //RC 33000778 : Funk�n� m�sta instance
            else
                return (this.ixs_ins) ? "jres:33000779" : "jres:29802871" //RC 33000779 : Konfigura�n� m�sta instance
        }
    }
}